// This is very similar to the Projects page, should we merge?

import React, {useEffect, useState} from 'react';
import {Container, Dropdown, Header} from 'semantic-ui-react';
import * as Prism from 'prismjs';
import {History} from 'history';
import ProjectListWithData from '../containers/ProjectList';
import makeComp from '../util/profiler';

interface PublicProjectsProps {
  history: History;
}

const PublicProjects: React.FC<PublicProjectsProps> = makeComp(
  ({history}) => {
    const [order, setOrder] = useState('lastActive');

    useEffect(() => {
      Prism.highlightAll();
    });

    const orderOptions = [
      {key: 'lastActive', value: 'lastActive', text: 'Last active'},
      {key: 'totalRuns', value: 'totalRuns', text: 'Number of runs'},
      {key: 'totalUsers', value: 'totalUsers', text: 'Number of users'},
      {key: 'totalRunTime', value: 'totalRunTime', text: 'Compute time'},
    ];

    return (
      <Container style={{marginTop: 48}}>
        <Header style={{marginRight: 200}}>Public Projects</Header>
        <div style={{margin: '26px 0'}}>
          {'Sort: '}
          <Dropdown
            selection
            options={orderOptions}
            value={order}
            onChange={(e, {value}) => setOrder(value as string)}
          />
        </div>
        <ProjectListWithData
          history={history}
          allowCreate
          order={order}
          anonymous
          emptyContent={<p>No Projects</p>}
        />
      </Container>
    );
  },
  {id: 'PublicProjects'}
);

// export dumb component for testing purposes
export {PublicProjects};

export default PublicProjects;
